import { render } from "./PdfDocument.vue?vue&type=template&id=b2b8e820&scoped=true"
import script from "./PdfDocument.vue?vue&type=script&lang=js"
export * from "./PdfDocument.vue?vue&type=script&lang=js"

import "./PdfDocument.vue?vue&type=style&index=0&id=b2b8e820&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2b8e820"]])

export default __exports__